export enum PublicApiAuthScope {
  OrdersRead = "orders_read",
  OrdersWrite = "orders_write",
  CustomersRead = "customers_read",
  CustomersWrite = "customers_write",
  ProductsRead = "products_read",
  ProductsWrite = "products_write",
  ReturnsRead = "returns_read",
  ReturnsWrite = "returns_write",
  WebhooksRead = "webhooks_read",
  WebhooksWrite = "webhooks_write",
  InventoryRead = "inventory_read",
  InventoryWrite = "inventory_write",
  InboundShipmentsRead = "inbound_shipments_read",
  InvoicesRead = "invoices_read",
  CustomerEventsWrite = "customer_events_write",
  StorefrontEventsWrite = "storefront_events_write",
  LocationsRead = "locations_read",
  LocationsWrite = "locations_write",
  ShippingRead = "shipping_read",
  ShippingWrite = "shipping_write",
  CampaignsRead = "campaigns_read",
  MarketingAutomationsRead = "marketing_automations_read",
  SegmentsRead = "segments_read",
  CampaignsAnalyticsRead = "campaigns_analytics_read",
  MarketingAutomationsAnalyticsRead = "marketing_automations_analytics_read",
  MarketingTemplatesRead = "marketing_templates_read",
  ConsolidationsRead = "consolidations_read",
}
